import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { IUserSessionStore, LOCAL_STORAGE_USER_PROFILE } from '../user.types'

export const defaultUserSession: IUserSessionStore = {
  user: {
    id: '',
    firstName: '',
    lastName: '',
    username: '',
    type: '',
    phone: '',
    aircallUserId: '',
    email: '',
  },
  membership: {
    id: '',
    status: '',
  },
  currentOrganization: {
    id: '',
    name: '',
  },
  organizations: [
    {
      id: '',
      name: '',
    },
  ],
  tokenPayload: {
    exp: 0,
    iat: 0,
    id: '',
    membershipId: '',
    organizationId: '',
    parentTokenId: '',
    sub: '',
    userId: '',
  },
  policies: [],
}

const initialState = {
  userSession: { ...defaultUserSession },
}

const userStore = createSlice({
  name: 'user',
  initialState: {
    userSession: {
      ...(localStorage.getItem(LOCAL_STORAGE_USER_PROFILE)
        ? (JSON.parse(
            localStorage.getItem(LOCAL_STORAGE_USER_PROFILE) as string,
          )?.userSession as IUserSessionStore)
        : initialState.userSession),
    },
  },
  reducers: {
    setUserSession: (
      state,
      action: PayloadAction<Partial<IUserSessionStore>>,
    ) => {
      state.userSession = {
        ...state.userSession,
        ...action.payload,
      }

      localStorage.setItem(LOCAL_STORAGE_USER_PROFILE, JSON.stringify(state))
    },
    resetUserSessionStore: (state) => {
      state = { ...initialState }
      localStorage.setItem(LOCAL_STORAGE_USER_PROFILE, '')
    },
  },
})

export const { setUserSession, resetUserSessionStore } = userStore.actions
export default userStore.reducer
